import { useGameStore } from '../../store/gameStore';
import { CHARACTERS } from '../../data';
import styles from './GameOverOverlay.module.css';

interface Props {
  winnerId: string;
}

export default function GameOverOverlay({ winnerId }: Props) {
  const { players, resetGame, setPhase } = useGameStore();
  const winner = players.find(p => p.id === winnerId);
  const char = winner ? CHARACTERS.find(c => c.id === winner.characterId) : null;

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <div className={styles.trophy}>🏆</div>
        <h1 className={styles.title}>游戏结束</h1>
        <div className={styles.winnerInfo}>
          <span className={styles.winnerEmoji}>{char?.emoji}</span>
          <div>
            <div className={styles.winnerName}>{winner?.name}</div>
            <div className={styles.winnerChar}>{char?.name}</div>
          </div>
        </div>
        <div className={styles.stats}>
          <div className={styles.statItem}>
            <span className={styles.statValue}>💰 {winner?.money}</span>
            <span className={styles.statLabel}>最终资产</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statValue}>🏠 {winner?.properties.length}</span>
            <span className={styles.statLabel}>拥有地产</span>
          </div>
        </div>
        <div className={styles.actions}>
          <button
            className={styles.restartBtn}
            onClick={() => { resetGame(); setPhase('lobby'); }}
          >
            🔄 再来一局
          </button>
        </div>
      </div>
    </div>
  );
}
